export enum EFontFamily {
    "IM Fell French Canon SC",
    "Share Tech Mono",
    "Open Sans"
}
